import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=9517a28e&scoped=true&"
import script from "./CardFooter.vue?vue&type=script&lang=js&"
export * from "./CardFooter.vue?vue&type=script&lang=js&"
import style0 from "./CardFooter.vue?vue&type=style&index=0&id=9517a28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9517a28e",
  null
  
)

export default component.exports